import React from 'react';
import { InfoSection, Pricing  } from '../../components';
import Escalators from '../../components/InfoSection/escalators';
// import { EscalatorOne, EscalatorTwo } from './Data';
function escalators() {
  return (
    <>
    <Pricing />

    <Escalators />
      {/* <InfoSection {...EscalatorOne} />
      <InfoSection {...EscalatorTwo} /> */}

    </>
  );
}

export default escalators;
